var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('loading-indicator'),_c('app-header'),_c('content-navigation'),_c('v-main',{ref:"main"},[_c('div',{style:(_vm.pageWrapStyle)},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_vm._t("default")],2)],1),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }